import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

const LABELS = { busqueda_red: "Búsqueda en la red", solicitud: "Solicitud de presentación", aceptacion: "Solicitud aceptada", presentada: "Presentación hecha",
  rechazo: "Solicitud rechazada", cierre: "Negocio cerrado", invitacion: "Invitación enviada", activacion: "Red desbloqueada" };

export default function ActividadPage() {
  const [page, setPage] = useState(1);
  const [d, setD] = useState(null);
  useEffect(() => { setD(null); api.get("/red/actividad", { params: { page } }).then((r) => setD(r.data)).catch((e) => toast.error(errMsg(e))); }, [page]);
  if (!d) return <div className="py-16 flex justify-center"><Loader2 className="w-6 h-6 animate-spin c-muted" /></div>;
  return (
    <div data-testid="actividad-page" className="space-y-3">
      <p className="text-xs c-text-2">Solo tú (y quien actúa a tu nombre) ve esta actividad. No incluye nombres de contactos.</p>
      {d.items.length === 0 ? <p data-testid="actividad-empty" className="c-card p-6 text-center text-sm c-text-2">Aún no hay actividad en la red.</p> : (
        <ul className="c-card divide-y c-line">
          {d.items.map((a) => (
            <li key={a.id} data-testid="actividad-item" className="p-3.5 text-sm">
              <p className="font-semibold">{LABELS[a.tipo] || a.tipo}</p>
              <p className="text-xs c-text-2">{[a.servicios.join(", "), a.ciudad, a.tipo === "busqueda_red" && a.resultados != null && `${a.resultados} resultado${a.resultados === 1 ? "" : "s"}`].filter(Boolean).join(" · ") || "—"}</p>
              <p className="text-[11px] c-muted">{new Date(a.fecha).toLocaleString("es-MX", { dateStyle: "medium", timeStyle: "short" })}</p>
            </li>
          ))}
        </ul>
      )}
      {d.pages > 1 && (
        <div className="flex items-center justify-between text-sm">
          <button data-testid="actividad-prev-btn" disabled={page <= 1} onClick={() => setPage(page - 1)} className="px-3 py-1.5 rounded-lg border c-line disabled:opacity-40">Anterior</button>
          <span data-testid="actividad-page-indicator" className="c-muted">Página {d.page} de {d.pages}</span>
          <button data-testid="actividad-next-btn" disabled={page >= d.pages} onClick={() => setPage(page + 1)} className="px-3 py-1.5 rounded-lg border c-line disabled:opacity-40">Siguiente</button>
        </div>
      )}
    </div>
  );
}
